export const CLOSED = 'Closed';
